import React, { useEffect } from 'react';

import { scrollToTop } from '../../util/helpers';
import { useSetPageTitle } from '../../v2/app-shell/usePageTitle';
import withHeadTag from '../HeadComponent';

interface HubPageLayoutProps {
  title?: string;
  children: React.ReactNode;
  noContainer?: boolean;
  // Retained for caller compatibility during the sidebar migration; the footer
  // (and its CTA border) now lives in the global app shell, so this is a no-op.
  // eslint-disable-next-line react/no-unused-prop-types
  showFooterBorder?: boolean;
}

const HubPageLayout = ({ title = 'HUB', children, noContainer }: HubPageLayoutProps) => {
  // Generic 'HUB' default is treated as no title; the app shell owns the header.
  useSetPageTitle(title === 'HUB' ? '' : title);

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="flex min-h-screen flex-col px-5 pb-5 md:px-10 md:pb-10">
      {!noContainer ? (
        <div className="container mb-20 mr-auto flex flex-grow lg:mb-0">
          <div className="relative w-full">{children}</div>
        </div>
      ) : (
        children
      )}
    </div>
  );
};

export default withHeadTag(HubPageLayout);
